import { injectGlobal } from 'emotion'
injectGlobal("@import url('https://fonts.googleapis.com/css?family=Caveat:400');body{}")